<ng-container *ngFor="let item of items; let i = index">
  <li>

    <!-- Handle main menu items -->
    <ng-container *ngIf="item!.below.length">
      <a class="list-item medium right-icon " href="#collapse-{{ indexMaster + '-' + i }}" data-bs-toggle="collapse"
        [ngStyle]="{'background-color': indexMaster.length == 1 ? '#cce6ff4a' : indexMaster.length == 3 ? '#EEF5FC' : indexMaster.length == 5 ? '#F2F6FA' : '#fff'}"
        aria-expanded="true" attr.aria-controls="collapse-{{ indexMaster  + '-' + i }}">
        <span class="list-item-title-icon-wrapper">
          <span class="fragment-link no-underline">{{ item!.title }}</span>
          <svg class="icon icon-sm icon-primary right icon" aria-hidden="true">
            <use href="assets/svg/sprites.svg#it-expand"></use>
          </svg>
        </span>
      </a>
      <ul class=" collapse " id="collapse-{{indexMaster + '-' + i}}">
        <item-menu [items]="item!.below" [indexMaster]="indexMaster + '-' + i"></item-menu>
      </ul>
    </ng-container>
    <!-- Handle sub menu items -->
    <ng-container *ngIf="!(item!.below.length)">
      <a class="list-item medium " [routerLink]="item?.link"
        [ngStyle]="{'background-color': indexMaster.length == 1 ? '#cce6ff4a' : indexMaster.length == 3 ? '#EEF5FC' : indexMaster.length == 5 ? '#F2F8FA' : '#fff'}"
        aria-expanded="true" attr.aria-controls="collapse-{{ indexMaster  + '-' + i }}">

        <span class="fragment-link no-underline">{{ item!.title }}</span>
      </a>
    </ng-container>
    <hr class="divider">
  </li>
</ng-container>